import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { API_URL, API_HEADERS } from '@/constants/ApiSetting';

/**
 * Axios instance configuration
 */
const api = axios.create({
  baseURL: API_URL || 'https://api.example.com',
  timeout: 30000, // 30 seconds timeout
  headers: {
    ...(API_HEADERS?.headers || {}),
  },
});

/**
 * Unified Error Handler for API requests
 * คง shape เดิมไว้ให้ใกล้ของเก่ามากที่สุด
 */
function handleError(error: AxiosError | any) {

  if (error?.response) {
    console.error('❌ API Error Response:', error.response.data);
    return {
      success: false,
      status: error.response.status,
      data: error.response.data,
    };
  }

  if (error?.code === 'ECONNABORTED') {
    console.error('⏱️ Request timeout:', error.config?.url);
    return {
      success: false,
      status: 408,
      data: { result_msg: 'Request timed out — server may be overloaded or unreachable. Please try again.' },
    };
  }

  if (error?.request) {
    console.error('⚠️ No response received:', error.config?.url);
    return {
      success: false,
      status: 0,
      data: { result_msg: 'Cannot reach server — possible causes: SSL certificate expired, CORS policy blocked, or server is down.' },
    };
  }

  console.error('⚙️ Request setup error:', error?.message);
  return { success: false, status: 0, data: { result_msg: error?.message || 'An unexpected error occurred.' } };
}

/**
 * Merge default API headers with per-request config
 * - คง Authorization จาก ApiSetting.ts
 * - เปิดให้ caller ส่ง headers/config เพิ่มได้เหมือนเดิม
 */
function mergeConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
  return {
    ...config,
    headers: {
      ...(API_HEADERS?.headers || {}),
      ...(config?.headers || {}),
    },
  };
}

export const APIGetRequest = async (
  URL: string,
  setHeaders?: AxiosRequestConfig
) => {
  try {
    const response = await api.get(URL, mergeConfig(setHeaders));
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export const APIPostRequest = async (
  URL: string,
  API_DATABODY: any,
  setHeaders?: AxiosRequestConfig
) => {
  try {
    const response = await api.post(URL, API_DATABODY, mergeConfig(setHeaders));
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};